import React from 'react';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const ClearCartPopup = (props) => {
    const { SetStatus } = props;
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { }, { clear_cart }] = useCartStore();
    const [{ }, { clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const loader = __check(['GET_CART_API_CALL', 'CLEAR_CART_API_CALL']).status;

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const clearedAllCart = async () => {
        await clear_cart({ miniCart: true });
        clear_all_system_alert({})
        onHide()
    };

    //By Ramya Kannan [Clear cart - Adobe script ]
    function clearCartEvent() {
        localStorage.setItem("adobeEventType", "cartRemovalEvent");
        let prodDetails = CART_DATA;
        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
        }
    }

    function clearQuoteCartEvent() {
        let quoteDetails = [];
        let prodDetails = [];
        Object.entries(quoteList).map((data, key) => {
            quoteDetails.push(data[1]);
            prodDetails.push(data[1].product);
        })

        prodDetails.map((data, ind) => {
            let copyObj = { ...data };
            copyObj.qas = get_inventory_by_id(prodDetails.ItemNumber)?.inventoryQty || 0;
            copyObj.subtotal = (quoteDetails[ind]?.subTotal_quantity_1);
            copyObj.unitPrice = quoteDetails[ind]?.price_quantity_1;
            copyObj.Quantity = quoteDetails[ind]?.quantity_0;
            copyObj.priceSource = getPricing(data)?.priceSource;
            copyObj.quoteID = quoteNumber;
            copyObj.quoteType = "online";
            prodDetails[ind] = copyObj;
        })

        let cartDetails = {
            additionSource: "PLP",
            cartType: "Quote",
            quoteID: quoteNumber,
            quoteType: "online",
        };
        localStorage.setItem("adobeEventType", "quoteCartRemovalEvent");

        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
        }
    }


    const getPricing = (ele) => {
        let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
        return priceValues && priceValues[0];
    }


    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" disabled={loader}
                        onClick={onHide}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Cart - Clear All</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="text-center mt-3 mb-5">
                            <p className="mb-0">Clearing your cart is permanent. This action is not reversible. Do you want to continue?</p>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm" data-dismiss="modal"
                                disabled={loader}
                                onClick={onHide}>
                                Cancel
                            </button>
                            <button onClick={clearedAllCart}
                                    disabled={loader}
                                type="button" className="bs5 btn btn-primary btn-sm w145">
                                {loader ? <i className="fa fa-spinner fa-spin"/> : "continue"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ClearCartPopup;